import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isPremiumUpsellExperimentEnabled = () => {
    // A/A Test
    FeatureGates.getExperimentValue('jsmgrowth-296_ipup_aa_test', 'isEnabled', false);

    // Main Experiment
    return FeatureGates.getExperimentValue('jsmgrowth-296_improving_premium_upsell_in_portal', 'isEnabled', false);
};
